import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ABSSplashScreen from '@abs/core/ABSSplashScreen';
import { showMessage } from 'app/store/abs/messageSlice';
import { logoutUser, setUser } from 'app/store/userSlice';
import absWebService from 'app/services/absWebService';
import { appendNavigationItem, removeNavigationItem } from 'app/store/abs/navigationSlice';
import authModules from './authModules';

const AuthContext = React.createContext();

function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(undefined);
  const [waitAuthCheck, setWaitAuthCheck] = useState(true);
  const dispatch = useDispatch();
  const user = useSelector(({ user }) => user);

  //on user change
  useEffect(() => {
    if (user?.Autologout != null) {
      const autologoutTimer = setInterval(() => autologoutTimerTick(), 1000);
      return () => {
        clearInterval(autologoutTimer);
      }
    }
  }, [user]);
  const autologoutTimerTick = () => {
    if (user?.Autologout != null && user?.Autologout <= new Date()) {
      absWebService.logout();
    }
  }

  useEffect(() => {
    absWebService.on('onAutoLogin', () => {
      /**
       * Sign in
       */
      absWebService
        .performAutoLogin(true)
        .then(user => {
          success(user);
        })
        .catch(error => {
          pass(error.message, 'error');
        });
    });

    absWebService.on('onLogin', (user) => {
      success(user);
    });

    absWebService.on('onLogout', () => {
      pass();

      dispatch(logoutUser());
    });


    absWebService.on('onAutoLogout', message => {
      if (message) {
        pass(message, 'info');
      }

      dispatch(logoutUser());
    });

    absWebService.on('onNoAccessToken', () => {
      //not logged in
      pass();
    });

    absWebService.on('onErrorOccured', message => {
      pass(message, 'error');

      dispatch(logoutUser());
    });

    absWebService.init();

    function success(user, message) {
      if (message) {
        dispatch(showMessage({ message }));
      }

      //update navigation
      switch (user?.tl?.peoplevisibility) {
        case "infos":
        case "live":
        case "livedetail":
        case "fullday":
          //remove it first, in case we log in again
          dispatch(removeNavigationItem('tl_employees'));
          //then set it new
          dispatch(appendNavigationItem(
            {
              id: 'tl_employees',
              title: 'Employees',
              translate: 'EMPLOYEES',
              type: 'item',
              icon: 'people_alt',
              url: '/tl/employees',
              auth: authModules.tl_default
            }, "timelite"));
          break;
      }

      //conditionally add tasks navigation based on Tasks_Enabled setting
      if (user?.tl?.tasksenabled === 1) {
        //remove it first, in case we log in again
        dispatch(removeNavigationItem('tl_tasks'));
        //then set it new
        dispatch(appendNavigationItem(
          {
            id: 'tl_tasks',
            title: 'Tasks',
            translate: 'TASKS',
            type: 'item',
            icon: 'assignment_turned_in',
            url: '/tl/tasks',
            auth: authModules.tl_default
          }, "timelite"));
      } else {
        //remove tasks navigation if disabled
        dispatch(removeNavigationItem('tl_tasks'));
      }

      user?.tl?.objects?.forEach(object => {
        //remove it first, in case we log in again
        dispatch(removeNavigationItem('tl_o_' + object.Object_key));
        //then set it new
        dispatch(appendNavigationItem(
          {
            id: 'tl_o_' + object.Object_key,
            title: object.Name_plural,
            // translate: 'PROJECTS',
            type: 'item',
            icon: object.Iconname,
            url: '/tl/o/' + object.Object_key,
            auth: authModules.tl_default
          }, "timelite"));
      });

      Promise.all([
        dispatch(setUser(user)),
        // You can receive data in here before app initialization
      ]).then((values) => {
        setWaitAuthCheck(false);
        setIsAuthenticated(true);
      });
    }

    function pass(message, variant = 'info') {
      if (message) {
        dispatch(showMessage({ message, variant: variant }));
      }

      setWaitAuthCheck(false);
      setIsAuthenticated(false);
    }
  }, [dispatch]);

  return waitAuthCheck ? (
    <ABSSplashScreen />
  ) : (
    <AuthContext.Provider value={{ isAuthenticated }}>{children}</AuthContext.Provider>
  );
}

function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
}

export { AuthProvider, useAuth };
